<div class="p-5 white-color text-center font-size-40">
  For any questions or concerns, please email us at <a class="cp-hyperlink" href="mailto:contact.cponline@icicilabs.com?Subject=DNM"
    target="_top">contact.cponline&#64;icicilabs.com</a>
</div>
